import React, {useState,useEffect} from "react";

import firebase from './database/firebase';
import { StyleSheet, Text, View, Button, TextInput, Dimensions,ActivityIndicator } from "react-native";
import { RadioButton } from 'react-native-paper';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const user_id = urlParams.get('uid');


const Translate = (props) => {

    const [isSelected, setSelection] = useState("yes");
    const [post, setPost] = useState(props.navigation.state.params.originalpost);
    const [translation, setTranslation] = useState("");
    const [destination, setDestination] = useState('Tfinal');
    const [lang, setLang] = useState('');
    const [count, setCount] = useState(0);
    const [loading,setLoading]=useState(false);
    const getTransData = async (user_id) => { 
      const dbRef = firebase.database().ref();
        dbRef.child("trans_posts_edit_less/").child(user_id).get().then((snapshot) => {
          if (snapshot.exists()) {
          // alert("Gowa el function: "+snapshot.child("translatedpost").val());
          setLang(snapshot.child("langUsed").val());
            //alert(snapshot.child("langUsed").val());
            //setTranslation(snapshot.val().translatedpost);
            return  snapshot.child("langUsed").val();
          } else {
            
           
            //alert("No data available");
            return "";
          }
        }).catch((error) => {
          console.error(error);
        });
        
        }
        useEffect(() => {
          getTransData(user_id);
         // alert(translation);
        }, []);
    if(loading ===true){
      return(
        <View style={styles.preloader}>
          <Text style={styles.text}>Translating the post....</Text> 
        <ActivityIndicator size="large" color="#0000ff"/>
        </View>
      )
      } 
      else{
        if(lang==='en')
        {
          return(
            <div>   
          <View style={styles.container}>
              
                    <Text style={styles.label}>We have noticed that your post is written in English. </Text>
                    <Text style={styles.label2}>Please write the post in a language other than English.</Text>

                  
            <View style={styles.buttonContainer}>
    
                    <Button 
                        color='#341ada'
                        title="Back"
                        style={StyleSheet.buttonStyle}
                        onPress={() => { props.navigation.navigate('Main', {detail: props.navigation.state.params.originalpost, language: props.navigation.state.params.language,uid:user_id}); }}> 
                    </Button>
            
            </View>
                    
          </View>
            </div>
          )
        }
        else if(lang===''){
          return(
            <View style={styles.preloader}>
              <Text style={styles.text}>Loading.....</Text> 
            <ActivityIndicator size="large" color="#0000ff"/>
            </View>
          )
        }
        else{
          return(
            <div>   
          <View style={styles.container}>
              
                    <Text style={styles.label}>Great! The post is written in {props.navigation.state.params.language}. </Text>

                  
            <View style={styles.buttonContainer}>
    
                    <Button 
                        color='#341ada'
                        title="Next"
                        style={StyleSheet.buttonStyle}
                        onPress={() => { props.navigation.navigate('Aftermain', {originalpost: props.navigation.state.params.originalpost, language: props.navigation.state.params.language,uid:user_id,firsttopic:props.navigation.state.params.firsttopic}); }}> 
                    </Button>
            
            </View>
                    
          </View>
            </div>
          )
        }

    }
}
const styles = StyleSheet.create({
	container: {
		padding: 20,
		flex: 1,
		display: "flex",
		marginRight: Dimensions.get('window').width/8,
    marginLeft: Dimensions.get('window').width/8,
		textAlign: 'center',
    alignItems: 'center',
		flexDirection: "column",
		justifyContent: "center",
    marginTop:Dimensions.get('window').height/4.5,
	},
  
	buttonContainer:{
    marginTop:Dimensions.get('window').height/6,
    width: '40%',
		alignSelf: 'center',
		marginVertical: 25,
        marginHorizontal: 30,
        flex:1,
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center'
	},

	text: {
		fontWeight: "bold",
		fontSize: 20
	},
	buttonStyle: {
		alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 12,
	paddingHorizontal: 60,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#341ada"
	},
    
	listContainer: {
        flexDirection: "column",
		paddingTop: 12
	},
	listItem: {
		fontSize: 20
	},
    checkboxContainer: {
        flexDirection: "row",
        justifyContent: "center",
        marginBottom: 2,
      },
      checkbox: {
        alignSelf: "center",
      },
      label: {
        //margin: 8,
       
        fontSize: 25,
      },
      label2: {
        //margin: 8,
        fontWeight: "bold",
        fontSize: 25,
      },
	textAreaContainer: {
		
		paddingTop: 12,
    paddingRight:Dimensions.get('window').width/15,
		paddingLeft: Dimensions.get('window').width/15,
		paddingBottom: 1,

	  },
	  textArea1: {
    backgroundColor:'#D3D3D3',
		height: 260,
		fontSize: 19,
		borderColor: '#000000',
		borderWidth: 1,
		justifyContent: "flex-start"
	  },
    textArea2: {
      height: 260,
      fontSize: 19,
      borderColor: '#341ada',
      borderWidth: 3,
      justifyContent: "flex-start"
      },
      preloader:{
        flex: 1,
        display: "flex",
        marginTop: 20,
        textAlign: 'center',
        flexDirection: "column",
        justifyContent: "center",
      },
      buttonStyle: {
        alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 12,
      paddingHorizontal: 60,
      borderRadius: 0,
      elevation: 13,
      backgroundColor:"#341ada"
      },
	  radioContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
	},radioContainer2: {
	//	padding: 1,
		//marginTop: 8,
		textAlign: 'center',
        flexDirection: "column",
	},
})
export default Translate